<template>
  <div class="box">
    <p class="titleModal mb-0">
      {{ $t(`treatmentProgram.step2.type`) }}
    </p>
    <v-row>
      <v-col>
        <VSelect
          v-model="data.type"
          :label="$t('treatmentProgram.steam.step3.probeDriven')"
          :items="probDrivenType"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="data.type === 'other' "
      class="p-1"
    >
      <VTextField
        v-model="data.otherText"
        :label="$t('treatmentProgram.steam.step2.other')"
        outlined
      />
    </v-row>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import { PROBE_DRIVEN_TYPE } from '@/constants/steamTreatmentPrograms';


export default {
    props: {
        probeDriven: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        probDrivenType() {
            return PROBE_DRIVEN_TYPE.map(key => ({
                name: this.$t(`treatmentProgram.steam.step3.probDrivenType.${key}`),
                key,
            }));
        },
    },
    watch: {
        probeDriven: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.probeDriven) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { probeDriven: this.data });
        },
    },
};
</script>
  <style lang="scss" scoped>
  .box {
      width: 100%;
      padding: 0 1rem;
  }
  </style>
